var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAvailable)?_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.file,"frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }